import { useModeratorStore, } from "../store/moderatorStore.ts";
import { ProfilePageModerator, } from "../components/features/ProfilePage/ProfilePageModerator.tsx";
import { ProfilePageDefault, } from "../components/features/ProfilePage/ProfilePageDefault.tsx";

export function ProfilePage() {
  const isModerator = useModeratorStore(state => state.isModerator,);

  return (
    <>
      {isModerator ? <ProfilePageModerator /> : <ProfilePageDefault />}
    </>
  );
}
